import API from "../../../app/api";

export const getSearchProductDetails = async (p_quality_slug,p_search_text, source='quality', includeComingSoon = 0) => {
  try {
    const response = await API.get(`/search/items?quality_slug=${p_quality_slug}&search=${p_search_text}&source=${source}&includeComingSoon=${includeComingSoon}`);
    return response.data?.data || [];
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch product details"
    );
  }
};